import { Component, OnInit } from "@angular/core";
import { MatTableDataSource } from "@angular/material";

@Component({
  selector: "app-calendar",
  templateUrl: "./calendar.component.html",
  styleUrls: ["./calendar.component.css"]
})
export class CalendarComponent implements OnInit {
  displayedColumns = ["date", "place", "details"];
  artkartC = new MatTableDataSource<Element>(ELEMENT_DATA);
  lkc = new MatTableDataSource<Element>(ELEMENT_DATA2);
  prokartLV = new MatTableDataSource<Element>(ELEMENT_DATA3);
  nordic = new MatTableDataSource<Element>(ELEMENT_DATA4);

  constructor() {}

  ngOnInit() {}
}

export interface Element {
  date: any;
  place: any;
  details: string;
}
const ELEMENT_DATA: Element[] = [
  { date: "2022-04-10", place: "Vilnius", details: "Sezono atidarymas" },
  { date: "2022-04-23", place: "Vilnius", details: "I Etapas" },
  { date: "2022-05-28", place: "Bačiūnai Šiauliai", details: "II Etapas" },
  { date: "2022-06-25", place: "Šiaulių DRMC", details: "III Etapas" },
  { date: "2022-08-06", place: "Smalininkai", details: "IV Etapas" },
  { date: "2022-09-10", place: "Bačiūnai Šiauliai", details: "V Etapas" },
  { date: "2022-10-08", place: "Anykščiai", details: "VI Etapas" }
];
const ELEMENT_DATA2: Element[] = [
  { date: "2019-05-11", place: "Vilnius", details: "I Etapas" },
  { date: "2019-05-25", place: "Smalininkai", details: "II Etapas" },
  { date: "2019-07-13", place: "Anykščiai", details: "III Etapas" },
  { date: "2019-08-03", place: "Aukštadvaris", details: "IV Etapas" },
  { date: "2019-09-14", place: "Anykščiai", details: "V Etapas" }
];
const ELEMENT_DATA3: Element[] = [
  { date: "2019-05-18", place: "Madona", details: "I Etapas" },
  { date: "2019-06-08", place: "Kandava", details: "II Etapas" },
  { date: "2019-07-06", place: "Madona", details: "III Etapas" },
  { date: "2019-08-10", place: "Smiltene", details: "IV Etapas" },
  { date: "2019-08-24", place: "Ropažu novads, SK333", details: "V Etapas" },
  { date: "2019-09-07", place: "Jelgava", details: "VI Etapas" }
];
const ELEMENT_DATA4: Element[] = [
  { date: "2019-09-29", place: "Kaunas", details: "4H" }
];



// WEBPACK FOOTER //
// ./src/app/calendar/calendar.component.ts